define([
	"csi",
	"csi/config",
	"csi/config/preferences",
	"csi/locale",
	"csi/xml"
], function (csi, config, configPreferences, locale, xml) {

	locale.registerDisplayNameResolver("CostScenario", locale.displayNameOrType);

	return {
		PATH_BOM: "Child:CostBOMItem/Child:__Parent__/Child:__Parent__",

		onAccessActionUpdateAttributesFromBOM: function (/*Context*/ctx, /*Action*/action) {
			var materialCost = ctx.getNode();
			return !xml.isEmptyURL(materialCost.CostBOMItem) || !xml.isEmptyURL(materialCost.CostQuote);
		},

		onAccessActionUpdateAttributesFromCostItem: function (/*Context*/ctx, /*Action*/action) {
			var operationCost = ctx.getNode();
			return !xml.isEmptyURL(operationCost.CostItem);
		},

		/**
		 * Handles the MaterialCosts view table row actions
		* @param {Context} ctx
		* @param {Action} action
		*/
		onAccessActionMaterialCostsAction: function (ctx, action) {
			var matCost = ctx.getNode();
			var pmNode = ctx.cache.getNode(matCost.CostBOMItem);
			var bomNode = ctx.cache.getPathNode(matCost, this.PATH_BOM);
			var lockThemePlacementList = (bomNode != null) ? config.getNodeSetting(bomNode, "LockThemePlacementList") : false;
			return (pmNode != null && !xml.isValidURL(pmNode.FromMaterialPlanPlacement)) || (!lockThemePlacementList);
		}
	};
});